import axios from 'axios'

export const state = {
	initialized: false,
	communityMagicLink: undefined,
	challengeKeyDate: undefined,
	challengeText: 'CHALLENGE ENDS',
	fetchInitalPromise: null,
}

export const getters = {
	communityMagicLink: state => state.communityMagicLink,
	challengeKeyDate: state => state.challengeKeyDate,
	initalized: state => state.initialized,
	challengeText: state => state.challengeText,
}

export const mutations = {
	setFetchInitalPromise(state, { promise }) {
		state.fetchInitalPromise = promise
	},
	setInitalized(state, flag) {
		state.initalized = flag
	},
	setCommunityMagicLink(state, link) {
		state.communityMagicLink = link
	},
	setChallengeKeyDate(state, date) {
		state.challengeKeyDate = date
	},
	setChallengeText(state, text) {
		state.challengeText = text
	},
}

const fetchChallengeMetaDataInternal = async (commit, resolve) => {
	try {
		const responses = await Promise.all([axios.post('v1/users/experiments/join_communities'), axios.get('v1/users/experiments/metadata')])

		const responseMetadata = responses[1]
		if (responseMetadata.data?.gary_vee_challenge_experiment?.key_date) {
			commit('setChallengeKeyDate', responseMetadata.data.gary_vee_challenge_experiment.key_date)
		}

		if (responseMetadata.data?.gary_vee_challenge_experiment?.challenge_text) {
			commit('setChallengeText', responseMetadata.data.gary_vee_challenge_experiment.challenge_text)
		}

		const responseJoinCommunity = responses[0]
		if (responseJoinCommunity.data?.gary_vee_challenge_experiment?.magic_link) {
			commit('setCommunityMagicLink', responseJoinCommunity.data.gary_vee_challenge_experiment.magic_link)
		}
	} catch (error) {
		console.error(error)
	}

	resolve()
}

export const actions = {
	async initalizeChallenge({ commit, state }) {
		let fetchInitalPromise = state.fetchInitalPromise
		if (fetchInitalPromise) {
			return fetchInitalPromise
		}

		// Outer promise that all callers await
		let fetchInitalResolve = null
		fetchInitalPromise = new Promise(resolve => {
			fetchInitalResolve = resolve
		})

		commit('setFetchInitalPromise', { promise: fetchInitalPromise })

		fetchChallengeMetaDataInternal(commit, fetchInitalResolve)

		return fetchInitalPromise
	},
}
